<template>
  <v-dialog :value="isLoadingIndicatorOpen" hide-overlay persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        {{ loadingMsg }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  name: "LoadingIndicator",
  data(){
    return {
      loadingMsg: "Guardando",
    };
  },
  computed:{
    ...mapGetters(['isLoadingIndicatorOpen']),
    // isLoadingIndicatorOpen(){return true}
  }
}
</script>